<template>
	<section class="item">

		<div class="inner">

			<img :srcset="sourceSet" :src="'/storage/images/'+option.image" :alt="option.title">

			<h2>{{option.title}}</h2>
            <p v-if="option.description">{{option.description}}</p>

			<ws-popup class="margin-tb-15" popup-title="Allergener" v-if="option.tags.length > 0">
				<section class="pop-inner">
	                <ul>
	                    <li v-for="tag in option.tags">
	                        <img :src="tag.icon_path" :alt="tag.name">
	                        {{tag.name}}
	                    </li>
	                </ul>
				</section>
            </ws-popup>

			<h1 v-if="asExtra">{{stripeAmount(option.as_extra_price).amount}},-</h1>
            <h1 v-if="option.premium">+{{stripeAmount(option.price).amount}},-</h1>


			<button :class="{'btn--secondary active':chosen, 'btn--secondary':!chosen}" class=" margin-tb-25" @click.prevent="toggle" :dusk="option.title" :id="option.title" v-if="!option.sold_out" >
				<span v-if="!chosen">Tilføj</span>
				<span v-else>Fjern</span>
			</button>

            <section class="btn--secondary disabled margin-tb-25" v-else>
                <span>Udsolgt</span>
            </section>



		</div>

	</section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "option-item",
		props:['option', 'selection', 'asExtra'],
		computed:{
			...mapGetters({
				order:'order',
			}),
			chosen(){
			    try{
                    if(!this.asExtra){
                        return this.order.details.selections.find(item => item.selection_id == this.selection.id).options.includes(this.option.id);
                    }

                    return this.order.details.extra_selections.find(item => item.extra_selection_id == this.selection.id).options.includes(this.option.id);
				}catch (e) {
					return false;
                }
			},
            sourceSet(){
                return '/storage/images/' + this.option.image_x1 + ' 1x, ' + '/storage/images/' + this.option.image + ' 2x';
            }
		},
		methods:{
          	toggle(){
          	    if(!this.asExtra){
          	        return this.$store.dispatch('setOptionForSelection', {
                        option:this.option,
                        selection:this.selection,
                    });
				}

                this.$store.dispatch('setOptionForExtraSelection', {
                    option:this.option,
                    selection:this.selection,
                });

			}
		},
    }
</script>

<style scoped>

</style>
